import { cva, type VariantProps } from "class-variance-authority";
import { Button, type ButtonProps } from "@/components/ui";
import { cn } from "@/lib/cn";
import "./wall-surface.css";

const wallChromeSize = cva("", {
  variants: {
    size: {
      sm: "",
      /* The header's 40px pills (mockup `.gp`). */
      bar: "h-10 gap-1.5 px-4 text-appkit-body",
      icon: "h-10 w-10 px-0",
    },
  },
  defaultVariants: { size: "sm" },
});

/**
 * A pill outside the cards (the header's controls, New, Retry): the wall
 * chrome, so it reads over the frost or any wallpaper, and marked
 * interactive, so it takes the click on the desktop wherever it sits.
 */
export function WallChromeButton({
  className,
  size,
  ...props
}: Omit<ButtonProps, "variant" | "size"> &
  VariantProps<typeof wallChromeSize>) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={cn(
        "wall-chrome text-secondary hover:text-primary focus-visible:ring-2 focus-visible:ring-accent",
        wallChromeSize({ size }),
        className,
      )}
      data-interactive="true"
      {...props}
    />
  );
}
